import { setUserId, setUserProperties, logEvent } from "firebase/analytics";
import firebase from "./firebase";
import type { User } from "../users/user.entity";
import type { Bussiness } from "../bussiness/bussiness.entity";
import type { AppSettings } from "../settings/app-settings.entity";
import { Permission } from "../users/user.entity";

type EventParams = Record<string, string | number | boolean | null | undefined>;

type UserAnalyticsContext = {
  user: User;
  bussiness?: Bussiness;
  appSettings?: AppSettings;
};

const normalizePath = (path: string) => path.split("?")[0] || "/";

class AnalyticsService {
  trackEvent(eventName: string, params: EventParams = {}) {
    logEvent(firebase.analytics, eventName, params);
  }

  trackPageView(path: string) {
    const cleanPath = normalizePath(path);
    this.trackEvent("page_view_custom", {
      page_path: cleanPath,
      page_section: cleanPath.split("/")[1] || "root",
    });
  }

  setUserContext({ user, bussiness, appSettings }: UserAnalyticsContext) {
    setUserId(firebase.analytics, user.id);
    setUserProperties(firebase.analytics, {
      user_role: user.hasPermission(Permission.ADMIN) ? "admin" : "staff",
      permissions_count: user.permissions.length,
      has_credit_sale_permission: user.hasPermission(Permission.ALLOW_CREDIT_SALE),
      has_custom_commission: user.commissionPercent !== null,
      business_key: bussiness?.key ?? "unknown",
      business_domain_count: bussiness?.domain?.length ?? 0,
      onboarding_completed: appSettings?.onboardingCompleted ?? false,
      cash_register_disabled: appSettings?.cashRegisterDisabled ?? false,
      default_commission_percent: appSettings?.commissionPercent ?? 0,
    });
  }

  clearUserContext() {
    setUserId(firebase.analytics, null);
  }
}

export const analyticsService = new AnalyticsService();
